import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { UploadFileService } from 'src/app/services/upload-file.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {

  @ViewChild("selectFile") selectFileDiv: ElementRef;
  @Input() selectedItem;
  selectedFiles: FileList;
  currentFile: File;
  progress = 0;
  message = "";

  fileInfos: Observable<any>;

  constructor(private uploadService: UploadFileService) { }

  ngOnInit() {
    
    this.fileInfos = this.uploadService.getFiles();
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.progress = 0;
    this.message = null;
  }

  upload() {
    this.progress = 0;
    this.message = "";
  
    if(this.selectedFiles.length > 6){
      alert("Maximum permissible no. of files is 6, please select 6 or less files to upload.");
      return;
    }

    for(let selectedFile of Array.from(this.selectedFiles)){
      if(selectedFile.name.includes(".pdf") || selectedFile.name.includes(".tif") || selectedFile.name.includes(".jpg")){

      } else{
        alert("Only PDF, TIFF and JPG files are permitted to be uploaded, please select only these type of files");
        return false;
      }
    }

    this.currentFile = this.selectedFiles.item(0);
    let index = 0;
    // Array.from(this.selectedFiles).forEach((currentFile, currentFileIndex) => {
      this.uploadService.upload(this.selectedFiles, 
        this.selectedItem.billOfLadingId).subscribe(event => {
          console.log("progress", this.progress);
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            this.message = "Upload successful";
            this.fileInfos = this.uploadService.getFiles();
          }
        },
        err => {
          this.progress = 0;
          this.message = 'Could not upload the file!';
          this.currentFile = undefined;
        });
    
      // this.selectedFiles = undefined;
    //  });
    
  }

  // clickSelection(){
  //   this.selectFileDiv.nativeElement.click();
  // }

  /**
   * on file drop handler
   */
   onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    // this.selectedFiles.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    // setTimeout(() => {
    //   if (index === this.selectedFiles.length) {
    //     return;
    //   } else {
    //     const progressInterval = setInterval(() => {
    //       if (this.selectedFiles[index].progress === 100) {
    //         clearInterval(progressInterval);
    //         this.uploadFilesSimulator(index + 1);
    //       } else {
    //         this.files[index].progress += 5;
    //       }
    //     }, 200);
    //   }
    // }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    // for (const item of files) {
    //   item.progress = 0;
    //   this.selectedFiles.push(item);
    // }
    // this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

}
